import { useTranslation } from 'react-i18next';
import { TaskType } from '@monorepo/shared';
import type { TaskDto } from '@monorepo/shared';
import { isActionableStatus } from './taskDisplay';

interface TaskActionCellProps {
  task: TaskDto;
  onAction: (task: TaskDto) => void;
}

const actionLabelKey: Record<TaskType, string> = {
  [TaskType.VALIDATION]: 'tasks.action.validate',
  [TaskType.DIFFUSION]: 'tasks.action.diffuse',
  [TaskType.READ]: 'tasks.action.start',
};

export const TaskActionCell = ({ task, onAction }: TaskActionCellProps) => {
  const { t } = useTranslation();
  const actionable = isActionableStatus(task.status);

  if (!actionable) {
    return <span className="text-sm text-gray-400">{t('tasks.action.done')}</span>;
  }

  return (
    <button
      type="button"
      onClick={() => onAction(task)}
      className="px-4 py-1.5 bg-primary text-white text-sm font-medium rounded-md hover:bg-opacity-90 transition"
    >
      {t(actionLabelKey[task.type])}
    </button>
  );
};
